export const blogConstants = {
  CREATE_BLOG: "CREATE_BLOG",
  UPDATE_BLOG: "UPDATE_BLOG",
  GET_BLOGS: "GET_BLOGS",
  GET_BLOG_BY_ID: "GET_BLOG_BY_ID",
  DELETE_BLOG: "DELETE_BLOG",
  GET_BLOGS_LIST: "GET_BLOGS_LIST",
  GET_DASHBOARD_STATS : "GET_DASHBOARD_STATS",
  GET_BLOGS_Attendance_By_Id:"GET_BLOGS_Attendance_By_Id",
  BLOGS_CHECK_OUT:"BLOGS_CHECK_OUT",
  BLOGS_CHECK_IN:"BLOGS_CHECK_IN",
  GET_ALL_BLOGS_ATTENDANCE: "GET_ALL_BLOGS_ATTENDANCE",
  BLOG_SESSIONS:"BLOG_SESSIONS",
  BLOG_SESSION_FORM_DATA: "BLOG_SESSION_FORM_DATA",
  BLOG_USER_ID: "BLOG_USER_ID",
  BLOG_ID: "BLOG_ID"
};
